import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AppInformationService } from '../../../core/app-information.service';
import { AuthService } from '../../../core/auth.service';
import { SessionInformationService } from '../../../core/session-information.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [],
    standalone: true,
})
export class HomeComponent implements OnInit {
    church: string;

    constructor(
        public appInfo: AppInformationService,
        public auth: AuthService,
        private router: Router,
        private sessionInfo: SessionInformationService
    ) {}

    ngOnInit() {
        switch (this.appInfo.settings.church) {
            case 'graafschap':
                this.church = 'Graafschap CRC';
                break;
        }
        this.appInfo.pleaseWaitHide();
    }

    logout() {
        this.auth.logout();
        this.sessionInfo.setItem('memberCode', null);
        this.sessionInfo.setItem('memberEmail', null);
        if (this.sessionInfo.getItem('portal')) {
            this.sessionInfo.setItem('portal', false);
            this.router.navigate(['/portal/login']);
        } else this.router.navigate(['/login']);
    }
}
